export const stringsKey = "MessageScheduleConfiguration";
export const englishStrings = {
	variablesPresent:
		"Cost estimates are not accurate due to dynamic variables present in the message body. Each message length will be different depending on the variable values provided.",
	totalCostToolTip: "Approximate Total Cost Per Group",
	totalGroupCostLabel: "Total Group Cost:",
	previewMessageSegmentToolTip: "Preview Message Segment",
	saveButton: "Save",
	approximateMessageCostToolTip: "Approximate Message Cost",
	totalGroupMessageLabel: "Total Group Message:",
	calculateApproximateMessageCostText:
		"To calculate approximate total message cost visit",
	calculateCostButton: "Calculate estimated costs",
	approximateTotalCostToolTip: "Approximate Total Cost",
	approximateTotalCostRecurringWarning:
		"Approximate total cost per scheduled send.",
	variableCostChangeWarning:
		"Message cost may change depending on the length of any included variables.",
	totalCostText: "Estimated Total Cost:",
	timeZoneListErrorMessage: "Error loading timezone list, Please try again",
	languageListErrorMessage: "Error loading language list, Please try again",
	messageCostErrorMessage:
		"Error loading message cost detail, Please try again",
};
